// @flow

import type {TreeItem, ExpandedTreeItem} from '../typedef';

type GetExpandedFlagArgs = {data: TreeItem, expandedIdsTree: ExpandedTreeItem, isFlat: boolean };

export const getExpandedFlag = ({data, expandedIdsTree, isFlat}: GetExpandedFlagArgs): boolean => {
    return isFlat || data.alwaysExpanded || data.alwaysExpandedSubcategory || data.transient ||
        (typeof expandedIdsTree.expanded === 'boolean' ? expandedIdsTree.expanded : (data.expanded || false));
};
